<template>
  <svg
    width="210"
    height="104"
    viewBox="0 0 210 104"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M166 60L208 60L208 71L166 71L166 60Z" fill="var(--accentColor)" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M167.885 61.2106C167.649 61.2091 167.456 61.3993 167.455 61.6355L167.211 100.186C167.209 100.422 167.399 100.615 167.636 100.616L206.186 100.86C206.422 100.862 206.615 100.672 206.616 100.436L206.861 61.885C206.862 61.6488 206.672 61.4562 206.436 61.4547L167.885 61.2106ZM164.455 61.6165C164.467 59.7235 166.011 58.1987 167.904 58.2107L206.455 58.4548C208.348 58.4668 209.872 60.011 209.86 61.904L209.616 100.455C209.604 102.348 208.06 103.872 206.167 103.86L167.617 103.616C165.724 103.604 164.199 102.06 164.211 100.167L164.455 61.6165Z"
      fill="var(--contrastColor)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M198.769 54.551C199.597 54.5562 200.265 55.2321 200.259 56.0605L200.211 63.7706C200.205 64.599 199.53 65.2663 198.701 65.2611C197.873 65.2558 197.205 64.58 197.211 63.7516L197.26 56.0415C197.265 55.2131 197.941 54.5458 198.769 54.551Z"
      fill="var(--contrastColor)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M175.639 54.4045C176.467 54.4098 177.134 55.0856 177.129 55.914L177.08 63.6241C177.075 64.4525 176.399 65.1198 175.571 65.1146C174.742 65.1093 174.075 64.4335 174.08 63.6051L174.129 55.895C174.134 55.0666 174.81 54.3993 175.639 54.4045Z"
      fill="var(--contrastColor)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M164.394 71.2544C164.399 70.426 165.075 69.7586 165.903 69.7639L208.309 70.0324C209.137 70.0376 209.805 70.7135 209.799 71.5419C209.794 72.3703 209.118 73.0376 208.29 73.0323L165.884 72.7638C165.056 72.7586 164.389 72.0828 164.394 71.2544Z"
      fill="var(--contrastColor)"
    />
    <path
      d="M109.062 3.9375L98.9375 14.0625"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M109.062 14.0625L98.9375 3.9375"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M23 42.5C32.5 20 58 8.5 92 8.5"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
    />
    <circle cx="22.5" cy="43.5" r="2.5" fill="var(--contrastColor)" />
    <path
      d="M185 43C175.5 20.5 150 9 116 9"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
    />
    <circle
      r="2.5"
      transform="matrix(-1 0 0 1 185.5 43.5)"
      fill="var(--contrastColor)"
    />
    <path
      d="M22.4167 79.5C29.1822 79.5 34.6667 74.0155 34.6667 67.25C34.6667 60.4845 29.1822 55 22.4167 55C15.6513 55 10.1667 60.4845 10.1667 67.25C10.1667 74.0155 15.6513 79.5 22.4167 79.5Z"
      stroke="var(--contrastColor)"
      stroke-width="3"
      stroke-miterlimit="10"
    />
    <path
      d="M44 93.1313C27.494 104.646 18.3 104.377 2 93.1313C2 93.1313 8 79.2894 23 79.5024C38 79.7154 44 93.1313 44 93.1313Z"
      fill="var(--accentColor)"
      stroke="var(--contrastColor)"
      stroke-width="3"
      stroke-linejoin="round"
    />
    <path
      d="M3.16675 91.1667C5.02623 87.6566 7.8636 84.7086 11.3643 82.6493C14.8651 80.59 18.8925 79.5 23.0001 79.5C27.1077 79.5 31.1351 80.59 34.6358 82.6493C38.1366 84.7086 40.9739 87.6566 42.8334 91.1667"
      stroke="var(--contrastColor)"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  components: {},
  props: [],
};
</script>
<style scoped></style>
